import React from "react";
import { Link } from "react-router-dom";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Footer from "../Header & Footer/kfooter";

const USLandingPage = () => (
  <div className="min-h-screen bg-white text-gray-900">
    <Konn3ctHeader />
    <main className="pt-20">
      <section className="max-w-7xl mx-auto px-6 py-20 lg:py-28 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#1A4699]">
            Konn3ct United States
          </p>
          <h1 className="mt-4 text-5xl lg:text-6xl font-black leading-tight">
            Seamless collaboration across the United States.
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-600 max-w-xl">
            A dedicated Konn3ct video meeting, webinar, and event hosting experience for US teams, businesses, and creators.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="https://dashboard.konn3ct.ng/register"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[#1A4699] px-6 py-3 font-semibold text-white hover:bg-blue-800"
            >
              Get started free
            </a>
            <Link
              to="/events"
              className="rounded-full border border-gray-300 px-6 py-3 font-semibold text-gray-800 hover:bg-gray-50"
            >
              Explore events
            </Link>
          </div>
        </div>

        <div className="rounded-3xl bg-gradient-to-br from-blue-50 via-white to-green-50 border border-blue-100 p-8 min-h-[360px] flex items-center justify-center">
          <div className="text-center">
            <div className="text-7xl font-black text-[#1A4699]">K3</div>
            <p className="mt-4 text-gray-500">Meet · Connect · Collaborate · Grow</p>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 border-y border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-6">
          {[
            ["High-definition video", "Crystal-clear audio, video, and screen sharing designed for modern teams."],
            ["Event management & ticketing", "Host public webinars, paid virtual conferences, and automated checkouts."],
            ["Enterprise reliability", "Encrypted communication channels, breakout rooms, and multi-device support."],
          ].map(([title, body]) => (
            <div key={title} className="rounded-2xl bg-white border border-gray-100 p-6">
              <h2 className="text-lg font-bold">{title}</h2>
              <p className="mt-2 text-sm leading-6 text-gray-600">{body}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default USLandingPage;
